module.exports = __webpack_public_path__ + "media/images/front/top/DB_lerning-1f6c6e8320b116346ff6efe77f815aa0.jpeg";